export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8604.d25fb2ce.jpg";